import type { ReceiveReceptionVerificationCode } from '@/entities/receive';

/** Form id — lets the footer's submit button live outside the `<form>`. */
export const RELEASE_GOODS_FORM_ID = 'release-goods-form';

/** Every free-text field of the release is 255 characters in legacy. */
export const RELEASE_GOODS_TEXT_MAX_LENGTH = 255;

/** Legacy order, and `D` first because the legacy select has no empty option. */
export const RECEPTION_VERIFICATION_CODES: ReceiveReceptionVerificationCode[] = ['D', 'P', 'E'];
